module.exports = __webpack_public_path__ + "img/mask.e3ceb84d.svg";